import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { ClipLoader } from "react-spinners";
import { Line } from "react-chartjs-2";

import { useAnalytics } from "./context";

export const TotalScoreGraph = () => {
  const { loading, report, title } = useAnalytics();


  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );


  if (loading)
    return (
      <div className="loader">
        <ClipLoader />
      </div>
    );

  if (!report || report.data.length === 0) {
    return <></>;
  }

  let suggestedMax = undefined;

  switch (report.formId) {
    case "0810E381-D1CD-4996-9C2E-4619A3B566AD":
      suggestedMax = 50;
      break;
    case "E889A966-B1A6-43FF-BCAA-C3138A0914F7":
      suggestedMax = 77;
      break;
    default:
      break;
  }
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Time",
        },
      },
      y: {
        suggestedMin: 0,
        suggestedMax: suggestedMax,
        title: {
          display: true,
          text: "Scores",
        },
      },
    },
  };

  return (
    <>
      <h2 style={{ paddingLeft: "32px" }}>{title}</h2>
      <h3 style={{ paddingLeft: "32px" }}>Average Total Score</h3>
      <div style={{ minHeight: "300px" }}>
        <Line data={report.data} options={options} />
      </div>
    </>
  );
};
